export default __webpack_public_path__ + "static/media/ishan.png.webp";